const autoNgTemplateLoaderTemplate1 = require('./header.html');

import './header.css';

export const rdHeader = {
  transclude: true,
  templateUrl: autoNgTemplateLoaderTemplate1,
};
